import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IbLayoutComponentsModule } from '@rs-bank/rs-layout';

import { SplittedInputModule } from 'ib/internetbank-core/ib-components/splitted-input/splitted-input.module';

import { CommonAppModule } from '../../common/common-app.module';
import { OperationWizardModule } from '../../common/operation-wizard/operation-wizard.module';
import { AppDownloadModule } from '../../shared/app-download/app-download.module';
import { SipPhoneCallModule } from '../../shared/sip-phone-call/sip-phone-call.module';
import { SvgCommonModule } from '../../shared/svg/svg-common.module';
import { TechnicalAlertsModule } from '../../shared/technical-alerts/technical-alerts.module';
import { UiModule } from '../../ui/ui.module';

import { BiometricsRegistrationErrorPopUpComponent } from './biometrics-registration-error-pop-up/biometrics-registration-error.pop-up.component';
import { BiometricsRegistrationOfferStatementPopUpComponent } from './biometrics-registration-offer-statement-pop-up/biometrics-registration-offer-statement.pop-up.component';
import { BiometricsRegistrationPopUpComponent } from './biometrics-registration-pop-up/biometrics-registration.pop-up.component';
import { BiometricsRegistrationSuccessPopUpComponent } from './biometrics-registration-success-pop-up/biometrics-registration-success.pop-up.component';
import { BiometricsRegistrationVerificationInfoPopUpComponent } from './biometrics-registration-verification-info-pop-up/biometrics-registration-verification-info.pop-up.component';
import { BiometricsRegistrationWizardComponent } from './biometrics-registration-wizard/biometrics-registration-wizard.component';
import { ConditionsModule } from './components/conditions/conditions.module';
import { RegistrationProductConfirmationCodeModule } from './components/registration-product-confirmation-code/registration-product-confirmation-code.module';
import { RegistrationProductInformationModule } from './components/registration-product-information/registration-product-information.module';
import { RegistrationProductInformationListModule } from './components/registration-product-information-list/registration-product-information-list.module';


@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,

		UiModule,
		OperationWizardModule,

		FormsModule,
		TechnicalAlertsModule,
		SvgCommonModule,
		SipPhoneCallModule,
		AppDownloadModule,
		RegistrationProductInformationModule,
		RegistrationProductInformationListModule,
		RegistrationProductConfirmationCodeModule,
		SplittedInputModule,
		ConditionsModule,

		IbLayoutComponentsModule,
	],
	declarations: [
		BiometricsRegistrationPopUpComponent,
		BiometricsRegistrationErrorPopUpComponent,
		BiometricsRegistrationSuccessPopUpComponent,
		BiometricsRegistrationVerificationInfoPopUpComponent,
		BiometricsRegistrationWizardComponent,
		BiometricsRegistrationOfferStatementPopUpComponent,
	],
	exports: [
		BiometricsRegistrationPopUpComponent,
		BiometricsRegistrationErrorPopUpComponent,
		BiometricsRegistrationSuccessPopUpComponent,
		BiometricsRegistrationVerificationInfoPopUpComponent,
		BiometricsRegistrationWizardComponent,
		BiometricsRegistrationOfferStatementPopUpComponent,
	],
	providers: [],
})
export class BiometricsRegistrationModule { }
